import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
	RemoveRoleModalState,
	Role,
	RolePermissionLabel
} from '../definitions';
import {
	KngButtonState,
	ModalComponent,
	ModalEvent,
	ModalState
} from 'kinetic-angular';
import { RolesPermissionsService } from '../roles-permissions.service';
import { RoutePermissions } from '../../../guards/permission/definitions';
import { Router } from '@angular/router';
import { ApplicationPath } from '../../../services/shared/shared-enums';
import { SharedService } from '../../../services/shared/shared.service';
import { SharedUtilService } from '../../../services/shared/shared-util.service';

@Component({
	selector: 'tmhna-portal-roles-permissions-list',
	templateUrl: './roles-permissions-list.component.html',
	styleUrls: ['./roles-permissions-list.component.scss']
})
export class RolesPermissionsListComponent implements OnInit
{
	get copyRoleActive(): boolean 
	{
		return this.roleService.copyRoleActive;
	}
	get addButtonState(): KngButtonState 
	{
		return this.roleService.addButtonState;
	}

	public screenWidth: number;

  @ViewChild(ModalComponent) modalComponent!: ModalComponent;
  @Input() editPermissions!: RoutePermissions | undefined;

  constructor(public roleService: RolesPermissionsService,  private readonly router: Router, private readonly sharedService : SharedService, private readonly sharedUtilService: SharedUtilService) 
  {
  	this.screenWidth = window.innerWidth;
  }

  ngOnInit(): void 
  {
	  this.addButtonState.disabled = !this.editPermissions?.actions?.includes('EDIT_DETAILS');
	  
  }


  isActiveRole(index: number) 
  {
  	return this.selectedRoleIndex === index;
  }

  set selectedRoleIndex(value: number) 
  {
  	this.roleService.updateSelectedRoleIndex(value);
  }

  get currentUserRole(): string 
  {
  	return this.roleService.currentUserRole;
  }

  get rolesList(): Role[] 
  {
  	return this.roleService.rolesList;
  }
  get selectedRoleIndex(): number 
  {
  	return this.roleService.selectedRoleIndex;
  }
  get roleToBeRemoved(): Role | null 
  {
  	return this.roleService.roleToRemove;
  }
  get usersAssignedToRoleToBeRemoved(): number 
  {
  	return this.roleService.countOfUserstoRemove;
  }

  get removeModalState(): ModalState 
  {
  	return this.roleService.removeModalState;
  }

  roleClick(selectedIndex: number) 
  {
  	this.selectedRoleIndex = selectedIndex;
  	this.roleService.updatedContent = true;
  }
  addRole() 
  {
  	this.roleService.addCustomRole();
  	this.roleService.updateAddRowActiveStatus(true);
  	this.addButtonState.disabled = true;
  }
  get labels(): RolePermissionLabel 
  {
  	return this.roleService.labels;
  }
  copyRole(roleIndex: number) 
  {
  	if (!this.copyRoleActive) 
  	{
  		this.roleService.copyCustomRole(roleIndex);
  		this.roleService.updateCopyRoleActiveStatus(true);
  	}
  }

  isNameTooLong(name: string) 
  {
  	const nameArray = name.split(' ');
  	const longWordIndex = nameArray.findIndex(
  		(word: string) => word.length > 12
  	);
  	return longWordIndex !== -1;
  }

  get removeRoleState(): RemoveRoleModalState | null 
  {
  	if (this.roleService.removeRoleModalState) 
  	{
  		this.removeModalState.hidden = false;
  	}
  	return this.roleService.removeRoleModalState;
  }

  removeRole(index: number, id: string) 
  {
  	this.roleService.getRemoveRoleState(id);
  	this.roleService.updateRoleToBeRemoved(this.rolesList[index]);
  }

  removeModalEvent(event: ModalEvent) 
  {
  	if (event.cta.label === 'Remove Role' && this.roleToBeRemoved?.id) 
  	{
  		this.roleService.removeRole(this.roleToBeRemoved.id);
  	}
  	this.removeModalState.hidden = true;
  	this.modalComponent?.closePopup();
  	this.removeRoleModalClosed();
  }

  removeRoleModalClosed() 
  {
  	this.roleService.updateRoleToBeRemoved(null);
  	this.roleService.removeRoleModalState = null;
  }

  highlightDefaultRoleName() 
  {
  	this.screenWidth = window.innerWidth;
  	if (!this.removeRoleState?.defaultUserRole) 
  	{
  		
	   return  this.labels.deleteConfirmation[0].headingSub;
  	}

  	if (this.screenWidth >= 768) 
  	{
  		return this.removeRoleState?.description.replace(
  			new RegExp(this.removeRoleState?.defaultUserRole, 'gi'),
  			(match) => 
  			{
  				return '<b>' + match + '</b>';
  			}
  		);
  	}
  	else 
  	{
  		return this.labels.deleteConfirmation[0].headingSub;
  	}
  }

  redirectToUserManagement()
  {
  	this.sharedUtilService.hideModalBackdrop();
	  this.sharedService.navigateMethod(this.router, ApplicationPath.userManagement);
  }
}
